import { render, staticRenderFns } from "./HelpItem.vue?vue&type=template&id=e96f652c&scoped=true&"
import script from "./HelpItem.vue?vue&type=script&lang=js&"
export * from "./HelpItem.vue?vue&type=script&lang=js&"
import style0 from "./HelpItem.vue?vue&type=style&index=0&id=e96f652c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96f652c",
  null
  
)

export default component.exports